/* Silo Digital — glossary definition cards (the COTR glossary pattern).
   Reads the term list from the [data-sd-glossary-terms] JSON script, walks the
   article body's text nodes, and wraps the FIRST occurrence of each term (or
   synonym) with a trigger that shows a small definition card on hover/focus
   (desktop) or tap (touch). DOM-based matching: never touches text inside
   links, headings, code, quotes, or other components.

   Rules mirrored from the WP plugin: case-insensitive whole-word match, first
   occurrence only, capped total matches per article, keyboard accessible
   (Enter/Space toggles, Escape closes), tap-outside dismisses. */
(function () {
  var MAX_MATCHES = 12;
  var SKIP = 'a, h1, h2, h3, h4, h5, h6, code, pre, kbd, button, blockquote, figcaption, script, style, .sd-glossary-term, .sd-inline-product, .sd-expert-quote, .sd-faq, .sd-key-takeaways';

  var dataEl = document.querySelector('[data-sd-glossary-terms]');
  var content = document.querySelector('.article-content');
  if (!dataEl || !content) { return; }

  var terms;
  try { terms = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!terms || !terms.length) { return; }

  // Longest first so "internal condom" wins over "condom"
  terms.sort(function (a, b) { return b.t.length - a.t.length; });

  function escapeRe(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

  var card = null;
  var activeTrigger = null;
  var hideTimer = null;

  function buildCard() {
    card = document.createElement('div');
    card.className = 'sd-glossary-card';
    card.id = 'sd-glossary-card';
    card.setAttribute('role', 'tooltip');
    card.hidden = true;
    card.innerHTML = '<p class="sd-glossary-card__term"></p><p class="sd-glossary-card__def"></p><a class="sd-glossary-card__link" href="#" hidden>Learn more<svg viewBox="0 0 16 16" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 8h10M9 4l4 4-4 4"/></svg></a>';
    card.addEventListener('mouseenter', function () { clearTimeout(hideTimer); });
    card.addEventListener('mouseleave', scheduleHide);
    document.body.appendChild(card);
  }

  function showCard(trigger) {
    if (!card) { buildCard(); }
    clearTimeout(hideTimer);
    if (activeTrigger && activeTrigger !== trigger) { activeTrigger.setAttribute('aria-expanded', 'false'); }
    activeTrigger = trigger;
    card.querySelector('.sd-glossary-card__term').textContent = trigger.dataset.term;
    card.querySelector('.sd-glossary-card__def').textContent = trigger.dataset.definition;
    var link = card.querySelector('.sd-glossary-card__link');
    if (trigger.dataset.url) { link.href = trigger.dataset.url; link.hidden = false; } else { link.hidden = true; }
    card.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    trigger.setAttribute('aria-describedby', 'sd-glossary-card');

    var r = trigger.getBoundingClientRect();
    var cw = card.offsetWidth;
    var left = r.left + window.scrollX + r.width / 2 - cw / 2;
    left = Math.max(12, Math.min(left, window.scrollX + document.documentElement.clientWidth - cw - 12));
    var top = r.top + window.scrollY - card.offsetHeight - 10;
    var below = top < window.scrollY + 8;
    if (below) { top = r.bottom + window.scrollY + 10; }
    card.classList.toggle('is-below', below);
    card.style.left = left + 'px';
    card.style.top = top + 'px';
  }

  function hideCard() {
    if (!card || card.hidden) { return; }
    card.hidden = true;
    if (activeTrigger) {
      activeTrigger.setAttribute('aria-expanded', 'false');
      activeTrigger.removeAttribute('aria-describedby');
      activeTrigger = null;
    }
  }

  function scheduleHide() {
    clearTimeout(hideTimer);
    hideTimer = setTimeout(hideCard, 180);
  }

  function bind(el) {
    el.addEventListener('mouseenter', function () { showCard(el); });
    el.addEventListener('mouseleave', scheduleHide);
    el.addEventListener('focus', function () { showCard(el); });
    el.addEventListener('blur', scheduleHide);
    el.addEventListener('click', function (evt) {
      if (el.tagName !== 'A') { evt.preventDefault(); }
      if (activeTrigger === el && card && !card.hidden) { hideCard(); } else { showCard(el); }
    });
    el.addEventListener('keydown', function (evt) {
      if (el.tagName !== 'A' && (evt.key === 'Enter' || evt.key === ' ')) {
        evt.preventDefault();
        el.click();
      }
    });
  }

  document.addEventListener('keydown', function (evt) { if (evt.key === 'Escape') { hideCard(); } });
  document.addEventListener('pointerdown', function (evt) {
    if (!evt.target.closest('.sd-glossary-term, .sd-glossary-card')) { hideCard(); }
  });

  // ---- Matching pass ----
  var total = 0;
  var walker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT, {
    acceptNode: function (node) {
      if (!node.nodeValue || !node.nodeValue.trim()) { return NodeFilter.FILTER_REJECT; }
      if (node.parentElement && node.parentElement.closest(SKIP)) { return NodeFilter.FILTER_REJECT; }
      return NodeFilter.FILTER_ACCEPT;
    }
  });
  var textNodes = [];
  while (walker.nextNode()) { textNodes.push(walker.currentNode); }

  terms.forEach(function (term) {
    if (total >= MAX_MATCHES) { return; }
    var words = [term.t].concat(term.s || []).filter(function (w) { return w && w.trim(); });
    if (!words.length) { return; }
    var re = new RegExp('\\b(' + words.map(escapeRe).join('|') + ')\\b', 'i');

    for (var i = 0; i < textNodes.length; i++) {
      var node = textNodes[i];
      if (!node.parentNode) { continue; }
      var m = re.exec(node.nodeValue);
      if (!m) { continue; }

      var matched = node.splitText(m.index);
      var tail = matched.splitText(m[0].length);
      // Keep the remainder scannable so later terms in the same original
      // text node can still match
      textNodes.push(tail);
      var el = document.createElement(term.u ? 'a' : 'span');
      el.className = 'sd-glossary-term';
      if (term.u) { el.href = term.u; } else { el.setAttribute('role', 'button'); el.setAttribute('tabindex', '0'); }
      el.setAttribute('aria-expanded', 'false');
      el.dataset.term = term.t;
      el.dataset.definition = term.d;
      if (term.u) { el.dataset.url = term.u; }
      el.textContent = matched.nodeValue;
      matched.parentNode.replaceChild(el, matched);
      bind(el);
      total++;
      break;
    }
  });
})();
